import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { adminService } from '../services/adminService';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminLoading, setAdminLoading] = useState(true);
  const [adminError, setAdminError] = useState(null);

  useEffect(() => {
    const checkAdminAccess = async () => {
      if (!isAuthenticated || !user) {
        setIsAdmin(false);
        setAdminLoading(false);
        return;
      }

      try {
        setAdminLoading(true);
        setAdminError(null);
        
        const response = await adminService.checkAccess();
        setIsAdmin(response.is_admin || false);
      } catch (error) {
        console.debug('Admin access check failed (expected for non-admin users):', error.message);
        setIsAdmin(false);
        setAdminError(error.message);
      } finally {
        setAdminLoading(false);
      }
    };

    checkAdminAccess();
  }, [isAuthenticated, user]);

  const value = {
    isAdmin,
    adminLoading,
    adminError
  };

  return (
    <AdminContext.Provider value={value}>
      {children}
    </AdminContext.Provider>
  );
};

export default AdminProvider;